<!-- 缴费凭证上传 -->
<template>
    <div class="el-voucher">
        <el-row class="page_content">
            <h1 class="head_title">缴费凭证上传</h1>
            <el-row style="padding-bottom:20px;">
                <el-col :span="8" style="text-align: center;">
                    缴费凭证预览
                </el-col>
                <el-col :span="8" style="padding-left:35px;">
                    缴费凭证上传
                </el-col>
            </el-row>
            <el-row style="padding-bottom:20px;">
                <el-col :span="8" style="text-align: center;min-width:200px;">
                    <img :src="headImg" style="border: 1px solid #f0f0f0;width: 160px;" />
                </el-col>
                <el-col :span="8" style="min-width:200px;">
                    <el-upload
                        class="avatar-uploader"
                        action=""
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i class="el-icon-plus avatar-uploader-icon" title="点击上传"></i>
                    </el-upload>
                </el-col>
            </el-row>
            <el-row style="padding-bottom:20px;color:red;padding-left:50px;">
                照片要求：由管理员自行添加文字
            </el-row>
        </el-row>
    </div>
</template>
<script>
import headImg from '@/images/user/headImg.png';
export default {
  name: "Voucher",
  data() {
    return {
        imageUrl:"",
        headImg:headImg,
    };
  },
  created() {
   
  },
  methods: {
    handleAvatarSuccess(res, file) {
        this.headImg = URL.createObjectURL(file.raw);
        console.log(this.headImg);
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
            this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-voucher{
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 160px;
        height: 228px;
        line-height: 228px;
        text-align: center;
    }
    .avatar {
         width: 160px;
        height: 228px;
        display: block;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/onlinePayment/Voucher.vue